import { pilotV3Background } from '~/services/serviceInstances';
import { RbacPermission } from '~/types/Rbac';

type BulkCheckPermissionResponse = {
  data: {
    type: 'permission_check';
    attributes: {
      results: Record<string, Record<string, boolean>>;
    };
  };
};

/**
 * Pilot caps `checks` at 50 per request and 400s anything larger with
 * `"checks cannot contain more than 50 items"`. Callers are responsible for
 * staying under it — see `checkAllPermissions`, which splits by action.
 */
export const MAX_BULK_PERMISSION_CHECKS = 50;

/**
 * Goes through `pilotV3Background`, not `pilotV3`: this fires unprompted on
 * every session (see `useInitializeUserPermissions`), so a 401 here — which
 * can mean "not authorized for one of these resource types" rather than
 * "session expired" — must not force a logout the way a person-initiated
 * request's 401 should.
 */
export const checkPermissionsBulk = async (
  permissions: RbacPermission[],
): Promise<Record<string, Record<string, boolean>>> => {
  const response = await pilotV3Background.post<BulkCheckPermissionResponse>(
    '/permission/bulk/',
    {
      data: {
        type: 'permission_check',
        attributes: {
          checks: permissions.map(({ resourceId, resourceType }) => ({
            resource_id: resourceId,
            resource_type: resourceType,
          })),
        },
      },
    },
  );
  return response.data.attributes.results;
};
